import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const WorkKeysIcon = ({ label = 'WorkKeys', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#fff" d="M31.7 43h236.6v39.4H31.7z"/><path d="M268.3 43v39.4H31.7V43h236.6m0-10H31.7c-5.5 0-10 4.5-10 10v39.4c0 5.5 4.5 10 10 10h236.6c5.5 0 10-4.5 10-10V43c0-5.5-4.5-10-10-10z" style="fill:#1d1d1b"/><path style="fill:#b1ce5f" d="M31.7 43H193v39.4H31.7z"/><path d="M193 43v39.4H31.7V43H193m0-10H31.7c-5.5 0-10 4.5-10 10v39.4c0 5.5 4.5 10 10 10H193c5.5 0 10-4.5 10-10V43c0-5.5-4.5-10-10-10z" style="fill:#1d1d1b"/><g><path style="fill:#fff" d="M31.7 130.3h236.6v39.4H31.7z"/><path d="M268.3 130.3v39.4H31.7v-39.4h236.6m0-10H31.7c-5.5 0-10 4.5-10 10v39.4c0 5.5 4.5 10 10 10h236.6c5.5 0 10-4.5 10-10v-39.4c0-5.5-4.5-10-10-10z" style="fill:#1d1d1b"/><g><path style="fill:#b1ce5f" d="M31.7 130.3h103v39.4h-103z"/><path d="M134.7 130.3v39.4h-103v-39.4h103m0-10h-103c-5.5 0-10 4.5-10 10v39.4c0 5.5 4.5 10 10 10h103c5.5 0 10-4.5 10-10v-39.4c0-5.5-4.5-10-10-10z" style="fill:#1d1d1b"/></g></g><g><path style="fill:#fff" d="M31.7 217.6h236.6V257H31.7z"/><path d="M268.3 217.6V257H31.7v-39.4h236.6m0-10H31.7c-5.5 0-10 4.5-10 10V257c0 5.5 4.5 10 10 10h236.6c5.5 0 10-4.5 10-10v-39.4c0-5.5-4.5-10-10-10z" style="fill:#1d1d1b"/><g><path style="fill:#b1ce5f" d="M31.7 217.6H215V257H31.7z"/><path d="M215 217.6V257H31.7v-39.4H215m0-10H31.7c-5.5 0-10 4.5-10 10V257c0 5.5 4.5 10 10 10H215c5.5 0 10-4.5 10-10v-39.4c0-5.5-4.5-10-10-10z" style="fill:#1d1d1b"/></g></g></svg>`}
    />
  )
}

WorkKeysIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { WorkKeysIcon }
